// Tiny element builder: text always goes through textContent, so manifest or feature strings can
// never inject markup.

type Child = Node | string | null | undefined | false;

export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Record<string, string> = {}, ...children: Child[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
  for (const c of children) if (c) el.append(c);
  return el;
}

/** Only http(s) links leave the page; anything else renders as plain text. */
export function link(href: string, text: string): HTMLElement {
  try {
    const url = new URL(href);
    if (url.protocol === "https:" || url.protocol === "http:") return h("a", { href: url.href, target: "_blank", rel: "noopener" }, text);
  } catch {
    // fall through
  }
  return h("span", {}, text);
}

export function formatDate(asOf: string): string {
  const d = new Date(`${asOf.slice(0, 10)}T00:00:00Z`);
  return Number.isNaN(d.getTime()) ? asOf : d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric", timeZone: "UTC" });
}

/** "Attribution · Licence · As of Oct 1, 2026": the provenance line every fact carries. */
export function provenance(entry: { attribution: string; licence: string; licence_url: string; as_of: string }): HTMLElement {
  return h("p", { class: "provenance" }, entry.attribution, " · ", link(entry.licence_url, entry.licence), " · ", `As of ${formatDate(entry.as_of)}`);
}
